module.exports = __webpack_public_path__ + "media/images/photos/france-f95de7e0789ded598d9bf87b62844b35.jpg";